/**
 * A functional component that renders a circular icon with a number inside.
 * The icon's background color and text color can be customized.
 *
 * @component
 * @param {Object} props - The props for the component.
 * @param {number} props.number - The number to display inside the icon.
 * @param {string} [props.backgroundColor] - The background color of the icon. Defaults to transparent if not provided.
 * @param {string} [props.textColor] - The color of the text inside the icon. Defaults to black if not provided.
 * @returns {JSX.Element} A styled circular icon with a number inside.
 */
import { makeStyles } from "@material-ui/core"
import { FC } from "react"

const NumberIcon: FC<{
  number: number
  backgroundColor?: string
  textColor?: string
}> = ({ number, backgroundColor, textColor }) => {
  const styles = useStyles()
  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      <span className={styles.text} style={{ color: textColor }}>
        {number}
      </span>
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    width: 28,
    height: 28,
    borderRadius: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderColor: "#00000008",
    borderWidth: 1,
  },
  text: {
    fontFamily: "Lato",
    fontSize: 18,
    fontWeight: 700,
    letterSpacing: 0,
  },
})

export default NumberIcon
